import { render, staticRenderFns } from "./CultureViImageAbolishAudit.vue?vue&type=template&id=74dfdfc6&scoped=true&"
import script from "./CultureViImageAbolishAudit.vue?vue&type=script&lang=js&"
export * from "./CultureViImageAbolishAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dfdfc6",
  null
  
)

export default component.exports